import { Button, CheckboxCard, CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';

export type Variant = {
  disabled: boolean;
  id: string;
  label: string;
  name: string;
  value: string;
};

type FormValues = {
  variant: string;
};

interface VariantsFormProps {
  defaultValues?: FormValues;
  onSubmit: (data: FormValues) => void;
  variants: Variant[];
}

export const VariantsForm: FC<VariantsFormProps> = ({
  defaultValues = { variant: '' },
  onSubmit,
  variants,
}) => {
  const { t } = useTranslation('product');
  const form = useForm<FormValues>({ defaultValues });
  const value = form.watch('variant');

  return (
    <form
      className="flex flex-col gap-y-4"
      onSubmit={(ev) => void form.handleSubmit(onSubmit)(ev)}
    >
      <div className="flex flex-col gap-3">
        <CheckboxWrapper error={form.formState.errors.variant?.message}>
          {variants.map((variant) => (
            <CheckboxCard
              key={variant.id}
              {...form.register('variant')}
              checked={variant.value === value}
              disabled={variant.disabled}
              id={variant.id}
              label={variant.label}
              name={variant.name}
              suffix={variant.disabled ? t('soldout') : undefined}
              type="radio"
              value={variant.value}
            />
          ))}
        </CheckboxWrapper>
      </div>
      <Button
        fullWidth
        label={t('addToOrder')}
        type="submit"
        variant="primary"
      />
    </form>
  );
};
